import axiosInstance from '../axios';
import endpoints from '../endpoints';

const voteService = {
  // Cast vote (public)
  castVote: async (voteData) => {
    const response = await axiosInstance.post(endpoints.votes.cast, voteData);
    return response.data;
  },

  // Add manual vote (admin)
  addManualVote: async (voteData) => {
    const response = await axiosInstance.post(endpoints.votes.manual, voteData);
    return response.data;
  },

  // Get votes for contest
  getContestVotes: async (contestId, params = {}) => {
    const { page = 1, pageSize = 20 } = params;
    const queryParams = new URLSearchParams({ page, pageSize });
    
    const response = await axiosInstance.get(`${endpoints.votes.byContest(contestId)}?${queryParams}`);
    return response.data;
  },

  // Get voting statistics
  getVoteStats: async (contestId) => {
    const response = await axiosInstance.get(endpoints.votes.stats(contestId));    
    return response.data;
  },

  // Get daily votes
  getDailyVotes: async (contestId, days = 7) => {
    const response = await axiosInstance.get(`${endpoints.votes.daily(contestId)}?days=${days}`);
    return response.data;
  },

  // In your voteService.js — add these three methods to the service object

deleteVote: async (voteId) => {
  const response = await axiosInstance.delete(`${endpoints.votes.delete(voteId)}`);
  return response.data;
},

bulkDeleteVotes: async (filters) => {
  const response = await axiosInstance.post(`${endpoints.votes.bulkDelete}`, filters);
  return response.data;
},

recalculateVoteCounts: async (contestId) => {
  const response = await axiosInstance.post(`${endpoints.votes.recalculate(contestId)}`);
  return response.data;
},

};

export default voteService;